import { useTranslation } from "react-i18next";
import useLocale from "./useLocale";

export default function useNoun() {
	const { t } = useTranslation(), locale = useLocale();

	return function getNoun(number: number, field: "projects" | "employees" | "categories") {

		let n = Math.abs(number), result = "";

		n %= 100;

		if(locale === "en") {
			if(number <= 1) result = `${number} ${t(`Noun.${field}.1`)}`; else result = `${number} ${t(`Noun.${field}.2`)}`;
			result = result.toLowerCase();
			return result;
		} else {

			if (n >= 5 && n <= 20) {
				result = `${number} ${t(`Noun.${field}.5`)}`;
			}

			n %= 10;

			if (n === 1) {
				result = `${number} ${t(`Noun.${field}.1`)}`;
			}

			if (n >= 2 && n <= 4) {
				result = `${number} ${t(`Noun.${field}.2`)}`;
			}

			if(!result) result = `${number} ${t(`Noun.${field}.5`)}`;

			result = result.toLowerCase();
			
			return result;
		}

	}
}